import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { commackConfig } from "./data";

export default function CommackPage() {
  return <CityPageTemplate config={commackConfig} />;
}